import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SeguridadService} from '@servicios/Seguridad.service';

import {ColaboradorComponent} from './colaborador/colaborador.component';
import { ReporteEvaluacionPendientePreguntaEnviadaComponent } from './preguntaenviada/preguntaenviada.component';
import { ReporteEvaluacionPendienteComponent } from './evaluacionpendiente/evaluacionpendiente.component';
import { ReporteEvaluacionComponent } from './evaluacion/evaluacion.component';
import { ColaboradorHijoComponent } from './colaboradorhijo/colaboradorhijo.component';

const routes: Routes = [
    {path: '', redirectTo: 'colaborador', pathMatch: 'full'},
    {path: 'colaborador', component: ColaboradorComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'colaboradorhijo', component: ColaboradorHijoComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'preguntaenviada', component: ReporteEvaluacionPendientePreguntaEnviadaComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'evaluacionpendiente', component: ReporteEvaluacionPendienteComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'evaluacion', component: ReporteEvaluacionComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ReporteRoutingModule {}
